// assets/wishlist.js
(() => {
  window.MVF_WISHLIST_LOADED = true;
  if (typeof console !== 'undefined') {
    console.debug('[MVF] wishlist.js geladen');
  }
})();